module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADxSURBVHgB7ZS7DcIwEIbPjmmoGCEjZIWMwAYpEVUaJOhMgaBMSQebwAiMkBGoaDA+fFF4RErwI6LLV0XR6cvp9x8DDNQwCGC23MZCq0xwcSx2q7JtRoAnJI20PiGwWGlFr2TbHAcPciknJAXAGBgraeOuWWcxSe838ZaOGE+7YiCcMv5IIXGROolDpIQ1ihCpVTxfbLJKasAIpq5Sq1hH/Eyb0jNTeKBYwBFrxlVv0VQMTRsALqOxSgspr73FoXKnHu9Ntg9zcHUsCR1obj4GfTd+0dzctIR3t8Trl25ujnRXZF2zXuJvOQNc/7orBv7PE+KeessEY8rUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_left.png
// module id = 9Rl2
// module chunks = 1